/* eslint-disable import/prefer-default-export */
/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from 'vue';
import { RawLocation, Route } from 'vue-router';
import { getInstance } from './useAuth0';

export type AuthGuard<V extends Vue = Vue> = (
  to: Route,
  from: Route,
  next: (to?: RawLocation | false | ((vm: V) => any) | void) => void,
) => void;

export const authGuard: AuthGuard<Vue> = (to, _from, next) => {
  const authService = getInstance();

  const fn = () => {
    if (!authService.isAuthenticated) {
      authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
      return;
    }

    next();
  };

  if (!authService.loading) {
    fn();
  }

  authService.$watch('loading', (loading: boolean) => {
    if (loading) {
      return;
    }

    fn();
  });
};
